import { customAlphabet } from "nanoid";
import PocketBase, { LocalAuthStore } from "pocketbase";

import { STORAGE_KEY_PREFIX } from "#composables/use-storage-state";
import { appConfig } from "#src/config";
import { sleep } from "#utilities/sleep";

/** Pocketbase client */
export const pb = new PocketBase(
  appConfig.links.api,
  new LocalAuthStore(`${STORAGE_KEY_PREFIX}-pb-auth`),
);

pb.afterSend = async (_response, data) => {
  // Apply fake delay in development to simulate network latency
  if (appConfig.development) {
    await sleep(250);
  }

  return data;
};

/** Pocketbase collection names */
export const pbCollectionNames = {
  account: "account",
  group: "group",
  list: "list",
  listSong: "listSong",
  song: "song",
  statsAccount: "statsAccount",
} as const;

// TODO: Consider extracting back-expansion (ie. via) into separate type/utility
/**
 * Pocketbase nested expansion fields (names) per collection
 *
 * NOTE: Nested expansion values **must** match PB field names!
 * NOTE: Back-expansion values **must** match expected PB `[collection]_via_[field]` format!
 */
export const pbCollectionExpansions = {
  group: ["account"],
  list: ["account", "group"],
  listSong: ["list", "song"],
  song: ["account"],
} as const;

/** Simulate/match Pocketbase ID (`[a-z0-9]{15}`) */
export const createPocketbaseId = () => {
  const nanoidAlphabet = customAlphabet("abcedfghijklmnopqrstuvwxyz0123456789", 15);
  return nanoidAlphabet(15);
};
